import { createAction, props } from '@ngrx/store';
import { ManifestApiError } from './manifest.errors';
import { Manifest } from 'src/app/admin/models/manifest.model';

export const LoadManifests = createAction('[Manifest] Load Manifests');

export const SetManifests = createAction(
  '[Manifest] Set Manifests',
  props<{ manifests: Manifest[] }>(),
);

export const CreateManifest = createAction(
  '[Manifest] Create Manifest',
  props<{ description: string; values: Record<string, unknown> }>(),
);

export const LoadCurrentManifest = createAction(
  '[Manifest] Load Current Manifest',
  props<{ id: number }>(),
);

export const SetCurrentManifest = createAction(
  '[Manifest] Set Current Manifest',
  props<{ manifest: Manifest }>(),
);

export const SetManifestError = createAction(
  '[Manifest] Set Manifest Error',
  props<{ error: ManifestApiError }>(),
);

export const RemoveManifestError = createAction('[Manifest] Remove Manifest Error');

export const GoToCurrentManifest = createAction(
  '[Manifest] Go To Current Manifest Project',
  props<{ id: number }>(),
);
